import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Music2, Heart, Baby, Globe2, Mic2 } from "lucide-react";
import { api } from "../../lib/api";

const ICONS = {
    "hindustani-vocal": Music2,
    "bhajans-devotional": Heart,
    "children-foundation": Baby,
    "online-classes": Globe2,
    "performance-training": Mic2,
};

export default function Courses() {
    const [courses, setCourses] = useState([]);

    useEffect(() => {
        api.get("/courses")
            .then((res) => setCourses(res.data || []))
            .catch(() => setCourses([]));
    }, []);

    return (
        <section
            id="courses"
            data-testid="courses-section"
            className="section-pad bg-cream"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
                    <div className="lg:col-span-7">
                        <div className="eyebrow">· Courses Offered ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon mt-4 leading-[1.05]">
                            Pathways into the
                            <span className="italic text-gold"> living tradition.</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 font-serif text-ink/80 text-xl leading-relaxed">
                        From the foundational <em>swara</em> to the heights of public
                        performance, every programme is anchored in the Guru-Shishya
                        parampara and tailored to the student’s stage of growth.
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
                    {courses.map((c, i) => {
                        const Icon = ICONS[c.id] || Music2;
                        return (
                            <div
                                key={c.id}
                                data-testid={`course-card-${c.id}`}
                                className="card-cream p-8 flex flex-col h-full"
                            >
                                <div className="flex items-center justify-between mb-6">
                                    <div className="w-12 h-12 flex items-center justify-center bg-maroon text-gold-300">
                                        <Icon size={20} />
                                    </div>
                                    <span className="eyebrow text-gold">
                                        {String(i + 1).padStart(2, "0")} / {String(courses.length).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl text-maroon leading-tight">
                                    {c.title}
                                </h3>
                                <p className="font-serif text-base lg:text-[17px] text-ink/80 leading-relaxed mt-4 flex-1">
                                    {c.summary}
                                </p>
                                <div className="mt-6 pt-5 border-t border-gold-100 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-inkmuted font-sans">
                                    <span>{c.level}</span>
                                    <span>{c.duration}</span>
                                </div>
                                <Link
                                    to="/register"
                                    data-testid={`course-enroll-${c.id}`}
                                    className="mt-5 inline-flex items-center justify-between text-maroon font-sans text-[12px] tracking-[0.25em] uppercase hover:text-gold transition-colors"
                                >
                                    Enroll in this course
                                    <span aria-hidden>→</span>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
